<script setup>
/**
 * Fork overlay (new file, no OSS equivalent) — the "Using <tool>" rows streamed while Eva works,
 * collapsed behind a step counter so the answer feed stays quiet (upstream ThinkingGroup pattern,
 * EVA_COPILOT copy). Collapsed by default: the steps are provenance, not the answer.
 */
import { ref } from 'vue';

defineProps({
  messages: { type: Array, required: true },
});

const isExpanded = ref(false);
</script>

<template>
  <div data-test-id="eva-thinking-steps" class="flex flex-col gap-2">
    <button
      type="button"
      class="group flex items-center gap-1.5 text-xs text-n-slate-10 transition-colors hover:text-n-slate-11"
      @click="isExpanded = !isExpanded"
    >
      <i
        class="size-3.5"
        :class="isExpanded ? 'i-lucide-chevron-down' : 'i-lucide-chevron-right'"
      />
      {{ $t('EVA_COPILOT.SHOW_STEPS') }}
      <span
        class="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-n-solid-3 px-1 text-xs font-medium text-n-slate-11"
      >
        {{ messages.length }}
      </span>
    </button>
    <ul v-show="isExpanded" class="mb-0 list-none space-y-1.5 pl-0">
      <li
        v-for="step in messages"
        :key="step.id"
        class="flex items-center gap-2 text-xs text-n-slate-11"
      >
        <i class="i-lucide-wrench size-3 shrink-0" />
        {{ step.message.content }}
      </li>
    </ul>
  </div>
</template>
